(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("85emE", function(module, exports) {
const $5e29eecc3a644a9f$var$leaflets = document.querySelectorAll(".i-leaflet");
function $5e29eecc3a644a9f$var$truncateText(element, link) {
    const contentElement = element.closest(".i-leaflet__content");
    if (!contentElement) return;
    let perexHeight = contentElement.clientHeight;
    const headerContentElement = contentElement.querySelector(".i-leaflet__header");
    if (headerContentElement) perexHeight = perexHeight - headerContentElement.clientHeight - 16;
    const locationsContentElement = contentElement.querySelector(".i-leaflet__locations");
    if (locationsContentElement) perexHeight = perexHeight - locationsContentElement.clientHeight - 16;
    const originalText = element.innerText;
    let truncatedText = originalText;
    const words = originalText.split(" ");
    while(words.length > 0){
        element.innerText = truncatedText; // Update text content
        if (element.scrollHeight > perexHeight) {
            words.pop(); // Remove the last word if overflow occurs
            truncatedText = words.join(" ") + "...";
            if (link && link.classList.contains("d-none")) link.classList.remove("d-none");
        } else break; // Stop if the content fits
    }
}
const $5e29eecc3a644a9f$var$init = ()=>{
    $5e29eecc3a644a9f$var$leaflets.forEach((leaflet)=>{
        if (leaflet.classList.contains("--initialized")) return;
        const perex = leaflet.querySelector(".i-leaflet__perex p") ?? leaflet.querySelector(".i-leaflet__perex");
        const perexLink = leaflet.querySelector(".i-leaflet__perex-link");
        const content = leaflet.querySelector(".i-leaflet__content");
        if (!perex || !perexLink || !content) return;
        if (!perex.dataset.originalText) perex.dataset.originalText = perex.innerHTML;
        leaflet.addEventListener("initLeaflet", ()=>{
            if (!leaflet.classList.contains("--initialized")) $5e29eecc3a644a9f$var$init();
        });
        if (leaflet.clientHeight < 1) return;
        $5e29eecc3a644a9f$var$truncateText(perex, perexLink);
        const resizeObserver = new ResizeObserver(()=>$5e29eecc3a644a9f$var$truncateText(perex, perexLink));
        resizeObserver.observe(perex);
        perexLink.addEventListener("click", (e)=>{
            e.preventDefault();
            perexLink.classList.toggle("--active");
            content.classList.toggle("--active");
            const linkTitle = perexLink.querySelector(".link__title");
            if (perex.dataset.originalText) perex.innerHTML = perex.dataset.originalText;
            if (!perexLink.classList.contains("--active")) $5e29eecc3a644a9f$var$truncateText(perex, perexLink);
            if (linkTitle && perexLink.classList.contains("--active") && perexLink.dataset.activeText) linkTitle.innerHTML = perexLink.dataset.activeText;
            else if (linkTitle && perexLink.dataset.defaultText) linkTitle.innerHTML = perexLink.dataset.defaultText;
        });
        leaflet.classList.add("--initialized");
    });
};
$5e29eecc3a644a9f$var$init();

});

})();
//# sourceMappingURL=leaflet-item.35f50d42.js.map
